import React from 'react';

const education = (
    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60">
        <g fill="none" fillRule="evenodd">
            <circle cx="30" cy="30" r="29.5" fill="#FF245E" stroke="#FF245E" />
            <g fill="#FFF">
                <path d="M40.882 28.996h1.176V39.19h-1.176z" />
                <path d="M15.52 28.259l14.89-5.037 14.333 5.037-14.612 4.896z" />
                <path d="M22.468 31.73l7.828 2.632 7.607-2.633v4.937l-7.607 3.247-7.828-3.283z" />
            </g>
        </g>
    </svg>
);

const emergencyResponse = (
    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60">
        <g fill="none" fillRule="evenodd">
            <circle cx="30" cy="30" r="29.5" fill="#FF245E" stroke="#FF245E" />
            <g stroke="#FFF" strokeLinecap="square" strokeWidth="7">
                <path d="M30.28 37.562V23M23 30.28h14.562" />
            </g>
        </g>
    </svg>
);

const environment = (
    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60">
        <g fill="none" fillRule="evenodd">
            <circle cx="30" cy="30" r="29.5" fill="#FF245E" stroke="#FF245E" />
            <g fill="#FFF">
                <path d="M34.371 17c.131.018.263.032.393.054.681.117 1.282.384 1.714.937.144.185.258.393.376.595.76 1.292 1.516 2.586 2.273 3.879l.057.09 1.597-.909-.042.103c-.766 1.723-1.532 3.447-2.296 5.17-.024.055-.05.075-.112.068-.337-.04-.674-.073-1.01-.11l-1.01-.11-1.002-.11-.994-.107-1.162-.127-.53-.057a.18.18 0 0 1-.087-.028l1.562-.888c-.012-.026-.019-.046-.03-.065-1.125-1.92-2.246-3.842-3.377-5.759a6.272 6.272 0 0 0-1.56-1.803 3.675 3.675 0 0 0-1.194-.635c-.008-.003-.015-.008-.037-.02.052-.004.09-.009.128-.01l1.569-.037c1.024-.023 2.047-.048 3.07-.072.442-.01.883-.021 1.324-.033.048-.001.095-.01.142-.016h.238zM29.517 38.269l3.525-4.72v.108c0 .54.001 1.082-.002 1.623 0 .074.022.094.096.093 2.21-.002 4.419.003 6.628-.004.819-.003 1.622-.116 2.39-.41a3.914 3.914 0 0 0 1.257-.748l-.133.246c-.958 1.734-1.91 3.471-2.878 5.2-.364.652-.891 1.14-1.622 1.386a2.225 2.225 0 0 1-.716.111l-4.897.001h-.118v1.799l-.02.007-3.51-4.692M20.74 39.024l-.827-1.333c-.823-1.326-1.649-2.65-2.467-3.98a3.031 3.031 0 0 1-.44-1.389 2.354 2.354 0 0 1 .341-1.398c.814-1.38 1.622-2.763 2.432-4.145l.05-.09-1.604-.914.626-.07 1.17-.129.986-.106 1.153-.128.985-.106c.283-.032.567-.06.85-.097.087-.011.133.006.172.094.764 1.724 1.533 3.446 2.3 5.168.01.02.017.041.034.082l-1.588-.903c-.018.027-.035.049-.048.072-1.102 1.881-2.206 3.763-3.305 5.646-.364.623-.647 1.28-.798 1.986-.124.578-.162 1.157-.023 1.74" />
                <path d="M28.675 35.38v5.775h-.094c-1.25 0-2.501.006-3.752-.002-.975-.007-1.836-.317-2.533-1.007a3.058 3.058 0 0 1-.9-1.856c-.046-.383.028-.76.131-1.13.17-.608.429-1.178.743-1.726.023-.04.047-.06.098-.06 2.085.002 4.17.002 6.255.002l.052.003M27.126 25.762l-5.069-2.884.043-.08c.629-1.074 1.253-2.15 1.889-3.22.476-.8 1.153-1.369 2.07-1.624.784-.22 1.556-.163 2.287.21.41.208.733.529 1.035.867.338.378.629.788.892 1.22.03.05.035.088.003.142l-3.112 5.31-.038.059M41.313 26.369l.638 1.088c.415.709.827 1.42 1.246 2.127.27.455.449.939.517 1.463.148 1.14-.333 2.34-1.366 3.023-.373.247-.802.365-1.238.458a8.803 8.803 0 0 1-1.59.17c-.066 0-.105-.018-.14-.077-1.03-1.765-2.063-3.528-3.096-5.29l-.041-.076 5.07-2.886" />
            </g>
        </g>
    </svg>
);

const health = (
    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60">
        <g fill="none" fillRule="evenodd">
            <circle cx="30" cy="30" r="29.5" fill="#FF245E" stroke="#FF245E" />
            <g fill="#FFF">
                <path d="M39.614 37.667H20.57V26h19.048l-.004 11.667zM27.713 21.333h4.762v2.334h-4.762v-2.334zm11.905 2.334h-4.762v-3.5A1.18 1.18 0 0 0 33.666 19h-7.143a1.18 1.18 0 0 0-1.191 1.167v3.5H20.57c-1.313 0-2.38 1.046-2.38 2.333v11.667c0 1.286 1.067 2.333 2.38 2.333h19.048c1.313 0 2.38-1.047 2.38-2.333V26c0-1.287-1.067-2.333-2.38-2.333z" />
                <path d="M31.284 28.333h-2.38v2.334h-2.382V33h2.381v2.333h2.381V33h2.381v-2.333h-2.38z" />
            </g>
        </g>
    </svg>
);

const lgbtq = (
    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60">
        <g fill="none" fillRule="evenodd">
            <circle cx="30" cy="30" r="29.5" fill="#FF245E" stroke="#FF245E" />
            <g fill="#FFF" stroke="#FFF" strokeLinecap="square">
                <path d="M31 28c-5.514 0-10 4.485-10 10h-2c0-6.617 5.383-12 12-12s12 5.383 12 12h-2c0-5.515-4.486-10-10-10z" />
                <path d="M31 33c-2.757 0-5 2.242-5 5h-2c0-3.309 2.335-7 7-7s7 3.691 7 7h-2c0-2.758-2.243-5-5-5z" />
                <path d="M31 22.889c-8.332 0-15.111 6.78-15.111 15.111H14c0-9.374 7.626-17 17-17 9.374 0 17 7.626 17 17h-1.889c0-8.332-6.78-15.111-15.111-15.111z" />
            </g>
        </g>
    </svg>
);

const migration = (
    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60">
        <g fill="none" fillRule="evenodd">
            <circle cx="30" cy="30" r="29.5" fill="#FF245E" stroke="#FF245E" />
            <g fill="#FFF" transform="translate(22 17)">
                <ellipse cx="10.119" cy="2.8" rx="2.833" ry="2.8" />
                <path
                    stroke="#FFF"
                    strokeWidth=".8"
                    d="M4.732 17.94l1.874 2.948c-.042 1.096-.176 1.865-.4 2.307-.472.93-3.28 4.043-3.94 4.543-.24.182-1.036.182-1.503-.253-.467-.434-.887-1.192-.24-2.035.431-.561 1.469-1.76 3.113-3.596l1.096-3.914z"
                />
                <path
                    stroke="#FFF"
                    strokeWidth=".8"
                    d="M8.582 16.402a889.075 889.075 0 0 1 6.045 9.549c.25.403.087 1.257-.404 1.58-.492.325-.959.394-1.432 0-.315-.262-2.804-4.045-7.467-11.35-.177-.35-.177-.948 0-1.796.178-.847.446-2.446.806-4.796-1.202.47-1.888.86-2.06 1.165-.258.459-.87.968-1.056 2.181-.186 1.214 0 2.057 0 2.057s.1 1.19-.818 1.19c-.918 0-.857-.932-.857-1.19 0-.258.194-3.478.571-4.238.378-.76 1.505-1.766 2.72-2.651 1.215-.885 4.208-1.431 4.779-1.119.57.313 1.127.78.896 2.232-.154.968-.728 3.364-1.723 7.186z"
                />
                <path
                    stroke="#FFF"
                    strokeWidth=".8"
                    d="M11.51 10.949l-.512 2.176c1.416 1.276 2.82 1.969 4.214 2.077 2.09.163 1.199-1.508.633-1.752-.566-.243-1.83-.517-2.106-.707-.184-.126-.927-.725-2.228-1.794z"
                />
            </g>
        </g>
    </svg>
);

const politics = (
    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60">
        <g fill="none" fillRule="evenodd">
            <circle cx="30" cy="30" r="29.5" fill="#FF245E" stroke="#FF245E" />
            <g fill="#FFF">
                <path d="M35.516 33.232L24.51 36.314l-2.515-4.356 8.172-7.99 5.348 9.264zm-17.23 1.155l1.917-1.107 2.266 3.926-1.917 1.107-2.267-3.926zM29.617 21.34l-9.708 9.492-2.758 1.592c-1.058.61-1.41 1.987-.785 3.07l2.267 3.926c.625 1.082 1.993 1.467 3.051.856l1.918-1.107 1.133 1.963 1.728-1.435-.784-1.36 11.837-3.315a1.088 1.088 0 0 0 .72-.653 1.143 1.143 0 0 0-.078-.987l-6.8-11.778a1.141 1.141 0 0 0-.815-.56 1.078 1.078 0 0 0-.926.296zM44.176 30.182l-1.891-.652a7.945 7.945 0 0 0-.373-6.112 7.949 7.949 0 0 0-4.586-4.056l.65-1.891a9.935 9.935 0 0 1 5.734 5.07 9.932 9.932 0 0 1 .466 7.64" />
                <path d="M40.315 29.109l-1.892-.653a3.967 3.967 0 0 0-.186-3.055 3.965 3.965 0 0 0-2.292-2.027l.65-1.892a5.958 5.958 0 0 1 3.44 3.042 5.966 5.966 0 0 1 .28 4.585" />
            </g>
        </g>
    </svg>
);

const poverty = (
    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60">
        <g fill="none" fillRule="evenodd">
            <circle cx="30" cy="30" r="29.5" fill="#FF245E" stroke="#FF245E" />
            <g stroke="#FFF" strokeWidth="1.6">
                <path d="M29.821 25.678a350.224 350.224 0 0 1 4.79-4.858c1.917-1.17 2.71-1.17 4.586-.877 1.85.877 3.678 2.818 4.921 4.47 1.069 2.098.537 3.768-.204 5.382-3.041 3.393-6.764 7.16-9.101 9.61-.907 1.008-3.133.684-3.392.208-.257-.471-.327-.729-.327-.938-1.018.976-.653.723-1.273 1.223 0 0-2.049 1.865-3.805-.98-3.333 0-3.333-2.328-2.383-3.943.348-.784 2.264-2.542 5.088-5.557M30.366 39.39l5.498-5.86M25.5 39.267L33.337 31M24 31l1.546 1.497" />
                <path d="M25.39 26.939c.7.722 1.476 1.648 2.92 2.969.683.711 1.665 1.011 2.64 0 1.093-.856.445-2.273 0-2.97-2.608-2.679-3.222-3.218-5.176-5.191-1.187-1.001-2.475-1.42-4.17-1.039-1.23.277-2.382 1.432-3.237 2.376-1.187 1.311-1.771 2.245-1.894 2.782-.212.922-.616 1.922 1.189 4.44 2.535 2.433 3.942 3.467 5.622 5.191" />
            </g>
        </g>
    </svg>
);

const racialJustice = (
    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60">
        <g fill="none" fillRule="evenodd">
            <circle cx="30" cy="30" r="29.5" fill="#FF245E" stroke="#FF245E" />
            <g fill="#FFF">
                <path d="M24.583 40.91h10.834v-1.092H24.583zM34.658 26.073l3.913-7.637 3.67 7.637z" />
                <path d="M38.45 29.873c2.094 0 3.792-1.71 3.792-3.819 0 .02-1.898-.084-3.792-.09a75.331 75.331 0 0 0-3.792.09c0 2.11 1.698 3.819 3.792 3.819zM24.908 29.127h-7.583l4.022-7.636z" />
                <path d="M21.117 32.946c2.094 0 3.791-1.71 3.791-3.818 0 .02-1.898-.085-3.791-.09a75.331 75.331 0 0 0-3.792.09c0 2.109 1.698 3.818 3.792 3.818zM22.417 38.727H36.5V42H22.417z" />
                <path d="M28.917 18h2.167v21.818h-2.167z" />
                <path d="M21.65 23.694l-.377-2.134 17.35-3.059.376 2.134z" />
            </g>
        </g>
    </svg>
);

const safety = (
    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60">
        <defs>
            <path
                id="a"
                d="M10.708 18L6 14.358l1.388-1.908 2.692 2.083L14.04 8 16 9.264z"
            />
        </defs>
        <g fill="none" fillRule="evenodd">
            <circle cx="30" cy="30" r="29.5" fill="#FF245E" stroke="#FF245E" />
            <g transform="translate(20 17)">
                <path
                    stroke="#FFF"
                    strokeWidth="2"
                    d="M11 26C.125 26 0 7.567 0 6.783c0-.41.217-.788.567-.988l9.9-5.653c.332-.19.735-.19 1.068 0l9.9 5.653c.35.2.565.577.565.988C22 7.567 21.876 26 11 26z"
                />
                <use fill="#FFF" transform="rotate(8 11 13)" xlinkHref="#a" />
            </g>
        </g>
    </svg>
);

const socialJustice = (
    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60">
        <g fill="none" fillRule="evenodd">
            <circle cx="30" cy="30" r="29.5" fill="#FF245E" stroke="#FF245E" />
            <g fill="#FFF">
                <path d="M18 37.516h13.978V42H18zM42.507 37.838L31.049 26.596l2.213-2.167c.365.315.926.3 1.272-.039a.903.903 0 0 0 0-1.29l-4.772-4.677a.934.934 0 0 0-1.31 0 .892.892 0 0 0 0 1.286l-.04-.039-6.058 5.94.039.043a.933.933 0 0 0-1.31 0 .892.892 0 0 0 0 1.286l4.767 4.681a.946.946 0 0 0 1.314 0 .903.903 0 0 0 0-1.29l.04.039 2.213-2.167L40.87 39.439a1.174 1.174 0 0 0 1.636 0 1.116 1.116 0 0 0 0-1.601" />
            </g>
        </g>
    </svg>
);

const womensRights = (
    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60">
        <g fill="none" fillRule="evenodd">
            <circle cx="30" cy="30" r="29.5" fill="#FF245E" stroke="#FF245E" />
            <path
                fill="#FFF"
                d="M25.333 25.2c0-2.647 2.093-4.8 4.667-4.8s4.667 2.153 4.667 4.8S32.574 30 30 30s-4.667-2.153-4.667-4.8M37 25.2c0-3.97-3.14-7.2-7-7.2s-7 3.23-7 7.2c0 3.56 2.528 6.518 5.833 7.092V36h-3.5v2.4h3.5V42h2.334v-3.6h3.5V36h-3.5v-3.708C34.472 31.718 37 28.76 37 25.2"
            />
        </g>
    </svg>
);

export default {
    education,
    emergencyResponse,
    environment,
    health,
    lgbtq,
    migration,
    politics,
    poverty,
    racialJustice,
    safety,
    socialJustice,
    womensRights
};
